import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import {
    PENDING, IDLE,
    PROVEN_NO, PROVEN_IN_USE, PRIOR_USE,
} from "const"
import { SilProjectDevice, SilProjectDeviceCreate } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,

    LoadSilDeviceById,
    LoadAccountPackageUsage,
    SaveSilDevice,
    SilProjectDeviceUpdateRequired,
    CountCalculatedSafetyFunctions,
    UpdateSilResultProjectDevice,
    IncreaseSilCalculations,

    closeModal,
    setSilDeviceReloadList,
    setSilDeviceReloadView,
    setSystemPackageUsage,
    setSilUpdateDeviceTargetDevice,
} from "client/store"
import {
    PageForm,
    Label,
    Input,
    Textarea,
    FileLoader,
    CheckboxWrapper,
    CheckButton,
    Collapse,
    Button,
    SpinnerIcon,

    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
} from "client/components"

import FormatScientific from "client/pages/sil/format/scientific"
import FormatPercentage from "client/pages/sil/format/percentage"
import FormatProbability from "client/pages/sil/format/probability"

import {
    RowStyled,
    FormGroupStyled,
    ButtonWrapper,
} from "../styled"

let isMounted: boolean

let updated = false
let recalculationRequired = false
let originEqual = false
let saveMode = 0

const Form = () => {
    const target = useSelector((state: StoreType) => state.silUpdate.device.targetDevice)
    const origin = useSelector((state: StoreType) => state.silUpdate.device.originDevice)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageUsage = useSelector((state: StoreType) => state.system.packageUsage)

    const modals = useSelector((state: StoreType) => state.system.modals)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [updateAllState, setUpdateAllState] = useState<StateType>(IDLE)
    const [saveState, setSaveState] = useState<StateType>(IDLE)
    const [recalculateCount, setRecalculateCount] = useState(0)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    const setTargetDevice = (device: SilProjectDevice) => {
        dispatch(setSilUpdateDeviceTargetDevice(device))
    }

    const updateAll = () => {
        const deviceUpdated: SilProjectDevice = {
            ...target,

            qidModelName: target.qidModelId ? origin.qidModelName : null,
            qidSafetyFunctionName: target.qidSafetyFunctionId ? origin.qidSafetyFunctionName : null,
            qidOptionName: target.qidOptionId ? origin.qidOptionName : null,
            qidDatapointDate: target.qidDatapointId ? origin.qidDatapointDate : null,

            name: origin.name,
            manufacturer: origin.manufacturer,
            logoId: origin.logoId,
            logo: origin.logo,
            description: origin.description,
            reference: origin.reference,
            status: origin.status,

            lowDemandMode: origin.lowDemandMode,
            highDemandMode: origin.highDemandMode,
            continuousMode: origin.continuousMode,
            type: origin.type,
            logicSolver: origin.logicSolver,
            provenInUse: origin.provenInUse,
            failureRate: origin.failureRate,

            sd: origin.sd,
            su: origin.su,
            dd: origin.dd,
            du: origin.du,

            sff: origin.sff,
            dc: origin.dc,
            pfd: origin.pfd,
            pfh: origin.pfh,
            sil: origin.sil,
        }
        setTargetDevice(deviceUpdated)
        onSave(deviceUpdated)
    }

    const onClose = () => {
        if (!isMounted) return

        if (isMounted && modals.length) {
            dispatch(closeModal())
        }
    }

    const onCancelConfirm = () => {
        setSaveState(IDLE)
        setUpdateAllState(IDLE)
        setRecalculateCount(0)
    }

    const onSave = (targetDevice: SilProjectDevice) => {
        if (saveMode === 1) setUpdateAllState(PENDING)
        if (saveMode === 2) setSaveState(PENDING)

        LoadSilDeviceById(targetDevice.id, userData.accountId, project.id).then((existingDevice) => {
            updated = false
            recalculationRequired = false

            if (
                existingDevice && ( // saving on account/project level
                    existingDevice.manufacturer !== targetDevice.manufacturer
                    || existingDevice.name !== targetDevice.name
                    || existingDevice.description !== targetDevice.description
                    || existingDevice.reference !== targetDevice.reference
                    || existingDevice.logoId !== targetDevice.logoId
                    || existingDevice.logicSolver !== targetDevice.logicSolver
                    || existingDevice.failureRate !== targetDevice.failureRate
                    || existingDevice.provenInUse !== targetDevice.provenInUse
                    || existingDevice.type !== targetDevice.type
                    || existingDevice.lowDemandMode !== targetDevice.lowDemandMode
                    || existingDevice.highDemandMode !== targetDevice.highDemandMode
                    || existingDevice.continuousMode !== targetDevice.continuousMode
                    || existingDevice.sd !== targetDevice.sd
                    || existingDevice.su !== targetDevice.su
                    || existingDevice.dd !== targetDevice.dd
                    || existingDevice.du !== targetDevice.du
                    || existingDevice.sff !== targetDevice.sff
                    || existingDevice.dc !== targetDevice.dc
                    || existingDevice.pfd !== targetDevice.pfd
                    || existingDevice.pfh !== targetDevice.pfh
                    || existingDevice.sil !== targetDevice.sil
                    || existingDevice.status !== targetDevice.status
                )
            ) {
                updated = true
            }

            if (
                existingDevice && project.id && ( // saving on project level
                    existingDevice.type !== targetDevice.type
                    || existingDevice.lowDemandMode !== targetDevice.lowDemandMode
                    || existingDevice.highDemandMode !== targetDevice.highDemandMode
                    || existingDevice.continuousMode !== targetDevice.continuousMode
                    || existingDevice.logicSolver !== targetDevice.logicSolver
                    || existingDevice.provenInUse !== targetDevice.provenInUse
                    || existingDevice.failureRate !== targetDevice.failureRate
                    || existingDevice.sd !== targetDevice.sd
                    || existingDevice.su !== targetDevice.su
                    || existingDevice.dd !== targetDevice.dd
                    || existingDevice.du !== targetDevice.du
                    || existingDevice.sff !== targetDevice.sff
                    || existingDevice.dc !== targetDevice.dc
                    || existingDevice.pfd !== targetDevice.pfd
                    || existingDevice.pfh !== targetDevice.pfh
                    || existingDevice.sil !== targetDevice.sil
                )
            ) {
                recalculationRequired = true
            }

            if (
                origin.qidModelName === targetDevice.qidModelName
                && origin.qidSafetyFunctionName === targetDevice.qidSafetyFunctionName
                && origin.qidOptionName === targetDevice.qidOptionName
                && origin.qidDatapointDate === targetDevice.qidDatapointDate
                && origin.manufacturer === targetDevice.manufacturer
                && origin.name === targetDevice.name
                && origin.logoId === targetDevice.logoId
                && origin.description === targetDevice.description
                && origin.reference === targetDevice.reference
                && origin.logicSolver === targetDevice.logicSolver
                && origin.failureRate === targetDevice.failureRate
                && origin.provenInUse === targetDevice.provenInUse
                && origin.type === targetDevice.type
                && origin.lowDemandMode === targetDevice.lowDemandMode
                && origin.highDemandMode === targetDevice.highDemandMode
                && origin.continuousMode === targetDevice.continuousMode
                && origin.sd === targetDevice.sd
                && origin.su === targetDevice.su
                && origin.dd === targetDevice.dd
                && origin.du === targetDevice.du
                && origin.sff === targetDevice.sff
                && origin.dc === targetDevice.dc
                && origin.pfd === targetDevice.pfd
                && origin.pfh === targetDevice.pfh
                && origin.sil === targetDevice.sil
                && origin.status === targetDevice.status
            ) {
                originEqual = true
            }

            if (recalculationRequired) {
                // check, if there are functions that use this device
                CountCalculatedSafetyFunctions({
                    projectId: project.id,
                    deviceId: targetDevice.deviceId,
                    projectDeviceId: !targetDevice.deviceId && !targetDevice.qidProductId ? targetDevice.id : null,
                    qidProductId: targetDevice.qidProductId,
                    qidModelId: targetDevice.qidModelId,
                    qidSafetyFunctionId: targetDevice.qidSafetyFunctionId,
                    qidOptionId: targetDevice.qidOptionId,
                    qidDatapointId: targetDevice.qidDatapointId,
                    qidMethod: targetDevice.qidMethod,
                }).then((count) => {
                    if (count) {
                        LoadAccountPackageUsage(userData.accountId)
                        .then((res) => {
                            dispatch(setSystemPackageUsage(res.packageUsage))
                            // show confirm
                            setRecalculateCount(count)
                        })
                    } else {
                        save(targetDevice)
                    }
                })
            } else {
                save(targetDevice)
            }
        })
    }

    const save = (targetDevice: SilProjectDevice) => {
        const newDeviceData: SilProjectDeviceCreate = {
            ...targetDevice,
            updated: !originEqual, // clear "updated" mark for equal devices
        }

        SaveSilDevice(
            targetDevice.id,
            newDeviceData,
            null, // don't check max number when saving existing device
            lang,
        ).then((res) => {
            const promiseArray: Promise<any>[] = []

            // update depending devices
            if (!res.validation) {
                // saving device on project level
                if (project.id && updated) {
                    // update project subsystems that based on this device
                    if (targetDevice.deviceId) { // device imported from account
                        promiseArray.push(
                            SilProjectDeviceUpdateRequired({ deviceId: targetDevice.deviceId }),
                        )
                    }
                    if (targetDevice.qidProductId) { // device imported from QID
                        promiseArray.push(
                            SilProjectDeviceUpdateRequired({
                                qidProductId: targetDevice.qidProductId,
                                qidModelId: targetDevice.qidModelId,
                                qidSafetyFunctionId: targetDevice.qidSafetyFunctionId,
                                qidOptionId: targetDevice.qidOptionId,
                                qidDatapointId: targetDevice.qidDatapointId,
                                qidMethod: targetDevice.qidMethod,
                            }),
                        )
                    }
                    if (!targetDevice.deviceId && !targetDevice.qidProductId) { // device created on project level
                        promiseArray.push(
                            SilProjectDeviceUpdateRequired({ projectDeviceId: targetDevice.id }),
                        )
                    }
                }

                // saving project device
                if (project.id) {
                    promiseArray.push(
                        UpdateSilResultProjectDevice({
                            projectId: project.id,
                            deviceId: targetDevice.deviceId,
                            projectDeviceId: !targetDevice.deviceId && !targetDevice.qidProductId ? targetDevice.id : null,
                            qidProductId: targetDevice.qidProductId,
                            qidModelId: targetDevice.qidModelId,
                            qidSafetyFunctionId: targetDevice.qidSafetyFunctionId,
                            qidOptionId: targetDevice.qidOptionId,
                            qidDatapointId: targetDevice.qidDatapointId,
                            qidMethod: targetDevice.qidMethod,
                        }),
                    )

                    if (recalculationRequired) {
                        promiseArray.push(
                            IncreaseSilCalculations(userData.accountId, dispatch),
                        )
                    }
                }
            }

            Promise.all(promiseArray).then(() => {
                if (isMounted) {
                    setUpdateAllState(IDLE)
                    setSaveState(IDLE)
                }
                if (res.validation) return

                dispatch(setSilDeviceReloadList(false))
                dispatch(setSilDeviceReloadView(false))
                setTimeout(() => {
                    dispatch(setSilDeviceReloadList(true))
                    dispatch(setSilDeviceReloadView(true))
                }, 0)

                onClose()
            })
        })
    }


    const { maxCalculations, usedCalculations } = packageUsage

    let leftCalculations = ""
    if (maxCalculations === null) leftCalculations = lang.unlimitedCalculations
    else leftCalculations = lang.leftCalculations.replace("{0}", usedCalculations.toString()).replace("{1}", maxCalculations.toString())

    let provenInUseOriginTitle: string
    if (origin.provenInUse === PROVEN_NO) provenInUseOriginTitle = lang.no
    if (origin.provenInUse === PROVEN_IN_USE) provenInUseOriginTitle = lang.provenInUse
    if (origin.provenInUse === PRIOR_USE) provenInUseOriginTitle = lang.priorUse

    let provenInUseTargetTitle: string
    if (target.provenInUse === PROVEN_NO) provenInUseTargetTitle = lang.no
    if (target.provenInUse === PROVEN_IN_USE) provenInUseTargetTitle = lang.provenInUse
    if (target.provenInUse === PRIOR_USE) provenInUseTargetTitle = lang.priorUse

    return (
        <div>
            <RowStyled top titleRow>
                <FormGroupStyled><Label>{lang.originDevice}</Label></FormGroupStyled>
                <FormGroupStyled><Label>{lang.currentDevice}</Label></FormGroupStyled>
            </RowStyled>
            <RowStyled danger={origin.name !== target.name}>
                <FormGroupStyled>
                    <Label>{lang.name}</Label>
                    <Input type="text" value={origin.name} readOnly />
                </FormGroupStyled>
                <FormGroupStyled>
                    <Label>{lang.name}</Label>
                    <Input type="text" value={target.name} readOnly />
                </FormGroupStyled>
                {
                    origin.name !== target.name && (
                        <ButtonWrapper>
                            <Button onClick={() => setTargetDevice({ ...target, name: origin.name })}>{lang.update}</Button>
                        </ButtonWrapper>
                    )
                }
            </RowStyled>
            <RowStyled danger={origin.manufacturer !== target.manufacturer}>
                <FormGroupStyled>
                    <Label>{lang.manufacturer}</Label>
                    <Input type="text" value={origin.manufacturer} readOnly />
                </FormGroupStyled>
                <FormGroupStyled>
                    <Label>{lang.manufacturer}</Label>
                    <Input type="text" value={target.manufacturer} readOnly />
                </FormGroupStyled>
                {
                    origin.manufacturer !== target.manufacturer && (
                        <ButtonWrapper>
                            <Button onClick={() => setTargetDevice({ ...target, manufacturer: origin.manufacturer })}>{lang.update}</Button>
                        </ButtonWrapper>
                    )
                }
            </RowStyled>
            <RowStyled danger={origin.logoId !== target.logoId}>
                <FormGroupStyled>
                    <Label>{lang.image}</Label>
                    <FileLoader value={origin.logo} readOnly />
                </FormGroupStyled>
                <FormGroupStyled>
                    <Label>{lang.image}</Label>
                    <FileLoader value={target.logo} readOnly />
                </FormGroupStyled>
                {
                    origin.logoId !== target.logoId && (
                        <ButtonWrapper>
                            <Button onClick={() => setTargetDevice({
                                ...target,
                                logoId: origin.logoId,
                                logo: origin.logo,
                            })}
                            >
                                {lang.update}
                            </Button>
                        </ButtonWrapper>
                    )
                }
            </RowStyled>
            <RowStyled danger={origin.description !== target.description}>
                <FormGroupStyled>
                    <Label>{lang.description}</Label>
                    <Textarea value={origin.description} readOnly />
                </FormGroupStyled>
                <FormGroupStyled>
                    <Label>{lang.description}</Label>
                    <Textarea value={target.description} readOnly />
                </FormGroupStyled>
                {
                    origin.description !== target.description && (
                        <ButtonWrapper>
                            <Button onClick={() => setTargetDevice({ ...target, description: origin.description })}>{lang.update}</Button>
                        </ButtonWrapper>
                    )
                }
            </RowStyled>

            {
                target.qidModelId && (
                    <RowStyled danger={origin.qidModelName !== target.qidModelName}>
                        <FormGroupStyled>
                            <Label>{lang.model}</Label>
                            <Input type="text" value={origin.qidModelName || ""} readOnly />
                        </FormGroupStyled>
                        <FormGroupStyled>
                            <Label>{lang.model}</Label>
                            <Input type="text" value={target.qidModelName || ""} readOnly />
                        </FormGroupStyled>
                        {
                            origin.qidModelName !== target.qidModelName && (
                                <ButtonWrapper>
                                    <Button onClick={() => setTargetDevice({
                                        ...target,
                                        qidModelName: origin.qidModelName,
                                    })}
                                    >
                                        {lang.update}
                                    </Button>
                                </ButtonWrapper>
                            )
                        }
                    </RowStyled>
                )
            }
            {
                target.qidSafetyFunctionId && (
                    <RowStyled danger={origin.qidSafetyFunctionName !== target.qidSafetyFunctionName}>
                        <FormGroupStyled>
                            <Label>{lang.safetyFunction}</Label>
                            <Input type="text" value={origin.qidSafetyFunctionName || ""} readOnly />
                        </FormGroupStyled>
                        <FormGroupStyled>
                            <Label>{lang.safetyFunction}</Label>
                            <Input type="text" value={target.qidSafetyFunctionName || ""} readOnly />
                        </FormGroupStyled>
                        {
                            origin.qidSafetyFunctionName !== target.qidSafetyFunctionName && (
                                <ButtonWrapper>
                                    <Button onClick={() => setTargetDevice({
                                        ...target,
                                        qidSafetyFunctionName: origin.qidSafetyFunctionName,
                                    })}
                                    >
                                        {lang.update}
                                    </Button>
                                </ButtonWrapper>
                            )
                        }
                    </RowStyled>
                )
            }
            {
                target.qidOptionId && (
                    <RowStyled danger={origin.qidOptionName !== target.qidOptionName}>
                        <FormGroupStyled>
                            <Label>{lang.option}</Label>
                            <Input type="text" value={origin.qidOptionName || ""} readOnly />
                        </FormGroupStyled>
                        <FormGroupStyled>
                            <Label>{lang.option}</Label>
                            <Input type="text" value={target.qidOptionName || ""} readOnly />
                        </FormGroupStyled>
                        {
                            origin.qidOptionName !== target.qidOptionName && (
                                <ButtonWrapper>
                                    <Button onClick={() => setTargetDevice({
                                        ...target,
                                        qidOptionName: origin.qidOptionName,
                                    })}
                                    >
                                        {lang.update}
                                    </Button>
                                </ButtonWrapper>
                            )
                        }
                    </RowStyled>
                )
            }
            {
                target.qidDatapointId && (
                    <RowStyled danger={origin.qidDatapointDate !== target.qidDatapointDate}>
                        <FormGroupStyled>
                            <Label>{lang.datapoint}</Label>
                            <Input type="text" value={origin.qidDatapointDate ? origin.qidDatapointDate.toString() : ""} readOnly />
                        </FormGroupStyled>
                        <FormGroupStyled>
                            <Label>{lang.datapoint}</Label>
                            <Input type="text" value={target.qidDatapointDate ? target.qidDatapointDate.toString() : ""} readOnly />
                        </FormGroupStyled>
                        {
                            origin.qidDatapointDate !== target.qidDatapointDate && (
                                <ButtonWrapper>
                                    <Button onClick={() => setTargetDevice({
                                        ...target,
                                        qidDatapointDate: origin.qidDatapointDate,
                                    })}
                                    >
                                        {lang.update}
                                    </Button>
                                </ButtonWrapper>
                            )
                        }
                    </RowStyled>
                )
            }
            {
                !target.qidProductId && (
                    <RowStyled danger={origin.reference !== target.reference}>
                        <FormGroupStyled>
                            <Label>{lang.reference}</Label>
                            <Input type="text" value={origin.reference} readOnly />
                        </FormGroupStyled>
                        <FormGroupStyled>
                            <Label>{lang.reference}</Label>
                            <Input type="text" value={target.reference} readOnly />
                        </FormGroupStyled>
                        {
                            origin.reference !== target.reference && (
                                <ButtonWrapper>
                                    <Button onClick={() => setTargetDevice({
                                        ...target,
                                        reference: origin.reference,
                                    })}
                                    >
                                        {lang.update}
                                    </Button>
                                </ButtonWrapper>
                            )
                        }
                    </RowStyled>
                )
            }

            <RowStyled danger={origin.status !== target.status} bottom>
                <FormGroupStyled>
                    <Label>{lang.status}</Label>
                    <Input type="text" value={lang[origin.status]} readOnly />
                </FormGroupStyled>
                <FormGroupStyled>
                    <Label>{lang.status}</Label>
                    <Input type="text" value={lang[target.status]} readOnly />
                </FormGroupStyled>
                {
                    origin.status !== target.status && (
                        <ButtonWrapper>
                            <Button onClick={() => setTargetDevice({ ...target, status: origin.status })}>{lang.update}</Button>
                        </ButtonWrapper>
                    )
                }
            </RowStyled>

            <Collapse show title={lang.safetyDetails}>
                <RowStyled
                    danger={
                        origin.lowDemandMode !== target.lowDemandMode
                        || origin.highDemandMode !== target.highDemandMode
                        || origin.continuousMode !== target.continuousMode
                    }
                    top
                >
                    <FormGroupStyled>
                        <Label>{lang.mode}</Label>
                        <CheckboxWrapper>
                            <CheckButton checked={origin.lowDemandMode} title={lang.modeLowDemand} readOnly />
                            <CheckButton checked={origin.highDemandMode} title={lang.modeHighDemand} readOnly />
                            <CheckButton checked={origin.continuousMode} title={lang.modeContinuous} readOnly />
                        </CheckboxWrapper>
                    </FormGroupStyled>
                    <FormGroupStyled>
                        <Label>{lang.mode}</Label>
                        <CheckboxWrapper>
                            <CheckButton checked={target.lowDemandMode} title={lang.modeLowDemand} readOnly />
                            <CheckButton checked={target.highDemandMode} title={lang.modeHighDemand} readOnly />
                            <CheckButton checked={target.continuousMode} title={lang.modeContinuous} readOnly />
                        </CheckboxWrapper>
                    </FormGroupStyled>
                    {
                        (
                            origin.lowDemandMode !== target.lowDemandMode
                            || origin.highDemandMode !== target.highDemandMode
                            || origin.continuousMode !== target.continuousMode
                        ) && (
                            <ButtonWrapper>
                                <Button onClick={() => setTargetDevice({
                                    ...target,
                                    lowDemandMode: origin.lowDemandMode,
                                    highDemandMode: origin.highDemandMode,
                                    continuousMode: origin.continuousMode,
                                })}
                                >
                                    {lang.update}
                                </Button>
                            </ButtonWrapper>
                        )
                    }
                </RowStyled>

                <RowStyled danger={origin.type !== target.type}>
                    <FormGroupStyled>
                        <Label>{lang.type}</Label>
                        <Input type="text" value={origin.type} readOnly />
                    </FormGroupStyled>
                    <FormGroupStyled>
                        <Label>{lang.type}</Label>
                        <Input type="text" value={target.type} readOnly />
                    </FormGroupStyled>
                    {
                        origin.type !== target.type && (
                            <ButtonWrapper>
                                <Button onClick={() => setTargetDevice({ ...target, type: origin.type })}>{lang.update}</Button>
                            </ButtonWrapper>
                        )
                    }
                </RowStyled>
                <RowStyled danger={origin.logicSolver !== target.logicSolver}>
                    <FormGroupStyled>
                        <Label>{lang.logicSolver}</Label>
                        <Input type="text" value={origin.logicSolver ? lang.yes : lang.no} readOnly />
                    </FormGroupStyled>
                    <FormGroupStyled>
                        <Label>{lang.logicSolver}</Label>
                        <Input type="text" value={target.logicSolver ? lang.yes : lang.no} readOnly />
                    </FormGroupStyled>
                    {
                        origin.logicSolver !== target.logicSolver && (
                            <ButtonWrapper>
                                <Button onClick={() => setTargetDevice({
                                    ...target,
                                    logicSolver: origin.logicSolver,
                                })}
                                >
                                    {lang.update}
                                </Button>
                            </ButtonWrapper>
                        )
                    }
                </RowStyled>
                <RowStyled danger={origin.provenInUse !== target.provenInUse}>
                    <FormGroupStyled>
                        <Label>{lang.provenReliabilityData}</Label>
                        <Input type="text" value={provenInUseOriginTitle} readOnly />
                    </FormGroupStyled>
                    <FormGroupStyled>
                        <Label>{lang.provenReliabilityData}</Label>
                        <Input type="text" value={provenInUseTargetTitle} readOnly />
                    </FormGroupStyled>
                    {
                        origin.provenInUse !== target.provenInUse && (
                            <ButtonWrapper>
                                <Button onClick={() => setTargetDevice({
                                    ...target,
                                    provenInUse: origin.provenInUse,
                                })}
                                >
                                    {lang.update}
                                </Button>
                            </ButtonWrapper>
                        )
                    }
                </RowStyled>
                <RowStyled danger={origin.failureRate !== target.failureRate} bottom>
                    <FormGroupStyled>
                        <Label>{lang.use}</Label>
                        <Input type="text" value={origin.failureRate ? lang.givenFailureRates : lang.givenSFF} readOnly />
                    </FormGroupStyled>
                    <FormGroupStyled>
                        <Label>{lang.use}</Label>
                        <Input type="text" value={target.failureRate ? lang.givenFailureRates : lang.givenSFF} readOnly />
                    </FormGroupStyled>
                    {
                        origin.failureRate !== target.failureRate && (
                            <ButtonWrapper>
                                <Button onClick={() => setTargetDevice({
                                    ...target,
                                    failureRate: origin.failureRate,
                                })}
                                >
                                    {lang.update}
                                </Button>
                            </ButtonWrapper>
                        )
                    }
                </RowStyled>
            </Collapse>

            <Collapse show title={lang.fillInGivenFailureRates}>
                <RowStyled danger={origin.sd !== target.sd} top>
                    <FormGroupStyled>
                        <FormatScientific title={lang.sd} data={origin.sd} inputView />
                    </FormGroupStyled>
                    <FormGroupStyled>
                        <FormatScientific title={lang.sd} data={target.sd} inputView />
                    </FormGroupStyled>
                    {
                        origin.sd !== target.sd && (
                            <ButtonWrapper>
                                <Button onClick={() => setTargetDevice({ ...target, sd: origin.sd })}>{lang.update}</Button>
                            </ButtonWrapper>
                        )
                    }
                </RowStyled>
                <RowStyled danger={origin.su !== target.su}>
                    <FormGroupStyled>
                        <FormatScientific title={lang.su} data={origin.su} inputView />
                    </FormGroupStyled>
                    <FormGroupStyled>
                        <FormatScientific title={lang.su} data={target.su} inputView />
                    </FormGroupStyled>
                    {
                        origin.su !== target.su && (
                            <ButtonWrapper>
                                <Button onClick={() => setTargetDevice({ ...target, su: origin.su })}>{lang.update}</Button>
                            </ButtonWrapper>
                        )
                    }
                </RowStyled>
                <RowStyled danger={origin.dd !== target.dd}>
                    <FormGroupStyled>
                        <FormatScientific title={lang.dd} data={origin.dd} inputView />
                    </FormGroupStyled>
                    <FormGroupStyled>
                        <FormatScientific title={lang.dd} data={target.dd} inputView />
                    </FormGroupStyled>
                    {
                        origin.dd !== target.dd && (
                            <ButtonWrapper>
                                <Button onClick={() => setTargetDevice({ ...target, dd: origin.dd })}>{lang.update}</Button>
                            </ButtonWrapper>
                        )
                    }
                </RowStyled>
                <RowStyled danger={origin.du !== target.du} bottom>
                    <FormGroupStyled>
                        <FormatScientific title={lang.du} data={origin.du} inputView />
                    </FormGroupStyled>
                    <FormGroupStyled>
                        <FormatScientific title={lang.du} data={target.du} inputView />
                    </FormGroupStyled>
                    {
                        origin.du !== target.du && (
                            <ButtonWrapper>
                                <Button onClick={() => setTargetDevice({ ...target, du: origin.du })}>{lang.update}</Button>
                            </ButtonWrapper>
                        )
                    }
                </RowStyled>
            </Collapse>

            {
                target.qidProductId === null && ( // don't show for qid based device - it has no these values
                    <Collapse show title={lang.fillInGivenSFF}>
                        <RowStyled danger={origin.sff !== target.sff} top>
                            <FormGroupStyled>
                                <FormatPercentage title={lang.sff} data={origin.sff} inputView />
                            </FormGroupStyled>
                            <FormGroupStyled>
                                <FormatPercentage title={lang.sff} data={target.sff} inputView />
                            </FormGroupStyled>
                            {
                                origin.sff !== target.sff && (
                                    <ButtonWrapper>
                                        <Button onClick={() => setTargetDevice({ ...target, sff: origin.sff })}>{lang.update}</Button>
                                    </ButtonWrapper>
                                )
                            }
                        </RowStyled>
                        <RowStyled danger={origin.dc !== target.dc}>
                            <FormGroupStyled>
                                <FormatPercentage title={lang.dc} data={origin.dc} inputView />
                            </FormGroupStyled>
                            <FormGroupStyled>
                                <FormatPercentage title={lang.dc} data={target.dc} inputView />
                            </FormGroupStyled>
                            {
                                origin.dc !== target.dc && (
                                    <ButtonWrapper>
                                        <Button onClick={() => setTargetDevice({ ...target, dc: origin.dc })}>{lang.update}</Button>
                                    </ButtonWrapper>
                                )
                            }
                        </RowStyled>
                        <RowStyled danger={origin.pfd !== target.pfd}>
                            <FormGroupStyled>
                                <FormatProbability title={lang.pfd} data={origin.pfd} inputView />
                            </FormGroupStyled>
                            <FormGroupStyled>
                                <FormatProbability title={lang.pfd} data={target.pfd} inputView />
                            </FormGroupStyled>
                            {
                                origin.pfd !== target.pfd && (
                                    <ButtonWrapper>
                                        <Button onClick={() => setTargetDevice({ ...target, pfd: origin.pfd })}>{lang.update}</Button>
                                    </ButtonWrapper>
                                )
                            }
                        </RowStyled>
                        <RowStyled danger={origin.pfh !== target.pfh}>
                            <FormGroupStyled>
                                <FormatProbability title={lang.pfh} data={origin.pfh} inputView />
                            </FormGroupStyled>
                            <FormGroupStyled>
                                <FormatProbability title={lang.pfh} data={target.pfh} inputView />
                            </FormGroupStyled>
                            {
                                origin.pfh !== target.pfh && (
                                    <ButtonWrapper>
                                        <Button onClick={() => setTargetDevice({ ...target, pfh: origin.pfh })}>{lang.update}</Button>
                                    </ButtonWrapper>
                                )
                            }
                        </RowStyled>
                        <RowStyled danger={origin.sil !== target.sil} bottom>
                            <FormGroupStyled>
                                <Label>{lang.sil}</Label>
                                <Input type="text" value={!origin.sil ? lang.notGiven : lang[`sil_${origin.sil}`]} readOnly />
                            </FormGroupStyled>
                            <FormGroupStyled>
                                <Label>{lang.sil}</Label>
                                <Input type="text" value={!target.sil ? lang.notGiven : lang[`sil_${target.sil}`]} readOnly />
                            </FormGroupStyled>
                            {
                                origin.sil !== target.sil && (
                                    <ButtonWrapper>
                                        <Button onClick={() => setTargetDevice({ ...target, sil: origin.sil })}>{lang.update}</Button>
                                    </ButtonWrapper>
                                )
                            }
                        </RowStyled>
                    </Collapse>
                )
            }

            <PageForm>
                <Row>
                    <Col xs={12}>
                        <Button
                            variant="success"
                            row
                            onClick={() => {
                                saveMode = 1
                                updateAll()
                            }}
                        >
                            {updateAllState === PENDING ? <SpinnerIcon /> : lang.updateAll}
                        </Button>
                        <Button
                            variant="success"
                            row
                            onClick={() => {
                                saveMode = 2
                                onSave(target)
                            }}
                        >
                            {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                        </Button>
                        <Button row onClick={onClose}>{lang.cancel}</Button>
                    </Col>
                </Row>

                <ConfirmWrapper
                    show={recalculateCount > 0}
                    onClose={onCancelConfirm}
                >
                    <Confirm align="center">
                        <ConfirmTitle>{lang.recalculationTitle}</ConfirmTitle>
                        <ConfirmDescription align="start">
                            {lang.recalculationDescription.replace("{0}", recalculateCount.toString())}
                        </ConfirmDescription>
                        <ConfirmDescription align="start">{leftCalculations}</ConfirmDescription>

                        <ConfirmBottom>
                            <Button row onClick={onCancelConfirm}>{lang.cancel}</Button>
                            <Button
                                variant="success"
                                row
                                disabled={maxCalculations !== null && usedCalculations >= maxCalculations}
                                onClick={() => {
                                    save(target)
                                    setRecalculateCount(0)
                                }}
                            >
                                {lang.confirm}
                            </Button>
                        </ConfirmBottom>
                    </Confirm>
                </ConfirmWrapper>
            </PageForm>
        </div>
    )
}
export default Form
